$.fn.isSubmitting = function() {
  var submit = $(this).find('[type=submit]');

  return $(this).hasClass('submitLock') && submit.hasClass('btn-loading');
}

$(function() {
  // touch to unlock form
  $('form.touchUnlock').each(function() {
    var form = $(this);
    var inputs = form.find('input, textarea, select');
    var submit = form.find('[type=submit]');
    inputs.on('change.unlock', function(ev) {
      if (form.isSubmitting()) {
        return false;
      }

      if ($(ev.currentTarget).prop('checked') === false) {
        submit.prop('disabled', true);
      } else {
        submit.prop('disabled', false);
      }
    });
  });

  // type to unlock form
  $('form.typeUnlock').each(function() {
    var form = $(this);
    var requiredOnly = form.hasClass('requiredOnly');
    var inputs = form.find('input, textarea');
    var submit = form.find('[type=submit]');
    inputs.on('change.unlock keyup.unlock input.unlock', function() {
      if (form.isSubmitting()) {
        return false;
      }

      var disable = false;
      
      for (var i = 0; i < inputs.length; i++) {
        var input = $(inputs[i]);
        if (input.val().length === 0 && (!requiredOnly || input.prop('required'))) {
          disable = true;
          break;
        }
      }

      submit.prop('disabled', disable);
    });
  });

  // submit lock form
  $('form.submitLock').on('submit.lock', function(e) {
    var submit = $(this).find('[type=submit]');
    submit.addClass('btn-loading');
    submit.prop('disabled', true);
    return true;
  });
});